import React, { Component } from 'react';
import { withFirebase } from '../../../utils/Firebase';
import { AuthUserContext } from '../../../utils/Session';


import './Checklist.scss'

const setup = [
  { id: 'account_created', title: 'Account Created', desc: '/checklist', status: true },
  { id: 'on_board', title: 'On Boarding Form ', desc: '/checklist', status: true },
  { id: 'fb_link', title: 'Facebook Linked', desc: '/checklist', status: true },
  { id: 'fb_pixel', title: 'Facebook Pixel Active', desc: '/checklist', status: false },
  { id: 'assets', title: 'Creative Assets Uploaded', desc: '/checklist', status: false },
  { id: 'media_spend', title: 'Media Spend Confirmed', desc: '/checklist', status: false },
]

class Checklist extends Component {
  
  render() {

    return (
      <div className="home container">
        <div className="home__details">
            <h1>Account Setup</h1>

            <div className="card">
                {setup.map(({ title, desc, status }) => (
                    <div className="setupItem">
                        <div className={"setupItem__status setupItem__status__" + status}></div>
                        <p className="setupItem__title">
                            {title}
                        </p>
                    </div>
                ))}
            </div>

        </div>
      </div>
    );
  }
}

export default withFirebase(Checklist);
